import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { HealthPlanModel } from 'app/models/health_plan.model';

@Injectable({
    providedIn: 'root',
})
export class HealthPlanService extends BaseService<HealthPlanModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'health_plan');
    }
}
